// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"pBLEDDpqEcp26i9eRS7rkQ=="};